import Vue from 'vue';
import FmGrid from '@/components/grid/FmGrid'
import basicContainer from '../components/basic-container/main'

import hignModal from '@/components/highSearch/hignModal.vue'
import previewModal from '@/components/highSearch/previewModal.vue'
import newTaskModal from '@/components/highSearch/newTaskModal.vue'
import noticeModal from '@/components/highSearch/noticeModal.vue'
import addMemberModal from '@/components/highSearch/addMemberModal.vue'
import keyValueSelect from "@/components/key-value/key-value-select"
import keyValueSelect2 from "@/components/key-value/key-value-select2"
import keyValueSpan from "@/components/key-value/key-value-span"
import newNoticeModal from '@/components/highSearch/newNoticeModal.vue'
import pushInto from '@/components/highSearch/pushInto.vue'
import pushInfoNewZip from '@/components/highSearch/pushInfoNewZip.vue'
import newtransfer from '@/components/new-transfer/new-transfer.vue'
import newDialog from '@/components/new-dialog/index.vue'
import sortData from '@/components/sort-data/index.vue'
import displayField from '@/components/display-field/index.vue'
import pullOut from '@/components/highSearch/pullOut.vue'
import pullOutNew from '@/components/highSearch/pullOutNew.vue'
import pullOutZip from '@/components/highSearch/pullOutZip.vue'
import tailDescribe from '@/components/highSearch/tailDescribe.vue'
import imPowerModal from '@/components/highSearch/imPowerModal.vue'
import noticeModalJD from '@/components/highSearch/noticeModal-JD.vue'
import addApiModal from '@/components/highSearch/addApiModal.vue'
import shieldModal from '@/components/shield-dialog/index.vue'
import alumni from '@/components/alumni/index.vue'
import alumniPublic from '@/components/alumniPublic/index.vue'
import serviceNumberEcharts from '@/components/echarts/service-number-echarts.vue'
import serviceFangwenEcharts from '@/components/echarts/service-fangwen-echarts.vue'

//注册全局容器
Vue.component('tailDescribe', tailDescribe)
Vue.component('basicContainer', basicContainer)
Vue.component('hignModal', hignModal)
Vue.component('previewModal', previewModal)
Vue.component('newTaskModal', newTaskModal)
Vue.component('noticeModal', noticeModal)
Vue.component('fm-grid', FmGrid)
Vue.component('addMemberModal', addMemberModal)
Vue.component('key-value-select', keyValueSelect)
Vue.component('key-value-select2', keyValueSelect2)
Vue.component('key-value-span', keyValueSpan)
Vue.component('new-notice-modal', newNoticeModal)
Vue.component('push-Into', pushInto)
Vue.component('pushInfoNewZip', pushInfoNewZip)
Vue.component('new-transfer', newtransfer)
Vue.component('new-dialog', newDialog)
Vue.component('sort-data', sortData)
Vue.component('display-field', displayField)
Vue.component('pull-Out', pullOut)
Vue.component('pull-Out-New', pullOutNew)
Vue.component('pull-Out-Zip', pullOutZip)
Vue.component('imPowerModal', imPowerModal)
Vue.component('JD-notice-modal', noticeModalJD)
Vue.component('addApiModal', addApiModal)
Vue.component('shieldModal', shieldModal)
Vue.component('alumni', alumni)
Vue.component('alumniPublic', alumniPublic)
Vue.component('service-number-echarts', serviceNumberEcharts)
Vue.component('service-fangwen-echarts', serviceFangwenEcharts)
